/**
 * Hashtag
 */
export class Hashtag {
  /**
   * Key
   */
  key: string;

  /**
   * Property inside DTO
   */
  property: string;

  /**
   * DTO name
   */
  dto: string;

  /**
   * Reflist name
   */
  reflist_name: string;

  /**
   * Value
   */
  value: string;

  /**
   * Percentage?
   */
  isPercentage: boolean;

  /**
   * Length?
   */
  isLength: boolean;

  /**
   * Currency?
   */
  isCurrency: boolean;

  /**
   * Area?
   */
  isArea: boolean;

  /**
   * ID
   */
  id: number;

  /**
   * Value is loaded?
   */
  isValueLoaded: boolean;

  /**
   * Type
   */
  type: string;

  /**
   * Secondary field name
   */
  secondaryField: string;
}
